<app-q-multi-select
  label="broker"
  placeholder="all"
  [options]="options$ | async"
  [ngModel]="value"
  (ngModelChange)="onClick($event)"
  [disabled]="disabled || (options$ | async)?.length === 2"
  [inline]="inline"
></app-q-multi-select>
